enum MAILING_PAGES {
  Outbox = 0,
  EmailSent = 1,
  Scheduled = 2,
  ContractMailings = 3,
  Recurring = 4,
  Sending = 5
}

export default MAILING_PAGES;
